"use client";

import {useSearchParams} from "next/navigation";
import React from "react";

export function Notification(
    { translations, ...props } : Omit<React.ComponentPropsWithoutRef<"div">, "id"> & { translations?: Record<string, string> }
) {

    const searchParams = useSearchParams();

    const info = searchParams.get("info") || "";
    const error = searchParams.get("error") || "";

    return (
        <>
            {info && (
                <div {...props}>
                    <p className="p-3 font-jost font-semibold text-normal text-center">
                        {translations && translations.hasOwnProperty(info) ? translations[info] : info}
                    </p>
                </div>
            )}
            {error && (
                <div {...props}>
                    <p className="p-3 text-center font-jost text-normal font-semibold text-rose-600">
                        {translations && translations.hasOwnProperty(error) ? translations[error] : error}
                    </p>
                </div>
            )}
        </>
    )
}
